/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type NewIssueSearchTransitionApp from '@jira/spa-apps__admin-pages-new-issue-search-settings/src/NewIssueSearchSettings.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyNewIssueSearchTransition: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof NewIssueSearchTransitionApp
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-new-issue-search-transition", jiraSpaEntry: "async-admin-pages-new-issue-search-transition" */ '@jira/spa-apps__admin-pages-new-issue-search-settings/src/NewIssueSearchSettings.tsx'
		),
	),
);

const AsyncNewIssueSearchTransition = (): React.JSX.Element => (
	<LazyPage
		Page={LazyNewIssueSearchTransition}
		pageId="jira-admin-pages-new-issue-search-transition"
		shouldShowSpinner
	/>
);

export default AsyncNewIssueSearchTransition;
